import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const Lightbox = ({ images, index, onClose, onIndex }) => {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
            else if (e.key === 'ArrowRight') onIndex((index + 1) % images.length);
            else if (e.key === 'ArrowLeft') onIndex((index - 1 + images.length) % images.length);
        };
        window.addEventListener('keydown', onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKey);
            document.body.style.overflow = prev;
        };
    }, [images.length, index, onClose, onIndex]);

    const stop = (e) => e.stopPropagation();

    return (
        <div
            className="fixed inset-0 z-[70] bg-black/95 backdrop-blur-sm flex items-center justify-center"
            onClick={onClose}
            data-testid="lightbox"
        >
            <button
                onClick={(e) => { stop(e); onClose(); }}
                className="absolute top-4 right-4 md:top-6 md:right-6 p-2 border border-white/20 text-white hover:bg-white/10 transition-colors"
                data-testid="lightbox-close"
                aria-label="Close"
            >
                <X className="h-5 w-5" />
            </button>

            {images.length > 1 && (
                <>
                    <button
                        onClick={(e) => { stop(e); onIndex((index - 1 + images.length) % images.length); }}
                        className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 p-2 md:p-3 border border-white/20 text-white hover:bg-white/10 transition-colors"
                        data-testid="lightbox-prev"
                        aria-label="Previous image"
                    >
                        <ChevronLeft className="h-6 w-6" />
                    </button>
                    <button
                        onClick={(e) => { stop(e); onIndex((index + 1) % images.length); }}
                        className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 p-2 md:p-3 border border-white/20 text-white hover:bg-white/10 transition-colors"
                        data-testid="lightbox-next"
                        aria-label="Next image"
                    >
                        <ChevronRight className="h-6 w-6" />
                    </button>
                </>
            )}

            <img
                src={images[index]}
                alt=""
                className="max-w-[95vw] max-h-[90vh] object-contain select-none"
                onClick={stop}
                data-testid="lightbox-image"
            />

            {images.length > 1 && (
                <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 label-caps text-white/70 text-xs">
                    {index + 1} / {images.length}
                </div>
            )}
        </div>
    );
};

export default Lightbox;
